// utils/validation.js

export const validateEmail = (email) => {
  const re = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;
  return re.test(String(email).toLowerCase());
};

export const validatePhoneNumber = (phone) => {
  const re = /^[0-9]{10}$/;
  return re.test(String(phone));
};

export const formatPhoneNumber = (phone) => {
  let cleanedInput = phone.replace(/\D/g, ""); // Remove non-numeric characters
  if (cleanedInput.startsWith("0")) {
    cleanedInput = cleanedInput.substring(1);
  }
  return cleanedInput;
};

export const notEmpty = (input) => {
  return input && input.trim().length > 0;
};

export const validatePassword = (password) => {
  const minLength = password.length >= 6;
  const hasUpperCase = /[A-Z]/.test(password);
  const hasLowerCase = /[a-z]/.test(password);
  const hasNumber = /[0-9]/.test(password);
  const hasSpecialChar = /[!@#$%^&*(),.?":{}|<>]/.test(password);

  return {
    minLength,
    hasUpperCase,
    hasLowerCase,
    hasNumber,
    hasSpecialChar,
    isValid:
      minLength && hasUpperCase && hasLowerCase && hasNumber && hasSpecialChar,
  };
};

// New validation function for number
export const validateNumber = (number) => {
  return !isNaN(number) && number !== "";
};

// New validation functions for title and image
export const validateTitle = (title) => {
  return title && title.trim().length > 0;
};

export const validateImage = (image) => {
  const allowedFileTypes = ["image/jpeg", "image/png"];
  return image && allowedFileTypes.includes(image.type);
};

export const validateURL = (url) => {
  const re = /^(ftp|http|https):\/\/[^ "]+$/;
  return re.test(String(url).toLowerCase());
};

export const validateStoreName = (storeName) => {
  const regex = /^[a-z0-9_]+$/;
  const minLength = storeName.length >= 3;
  const hasAlphabets = (storeName.match(/[a-z]/g) || []).length >= 3;
  const startsWithUnderscore = storeName.startsWith("_");
  const isOnlyNumbers = /^[0-9_]+$/.test(storeName);

  let error = "";

  if (!minLength) {
    error = "Store name must be at least 3 characters long.";
  } else if (startsWithUnderscore) {
    error = "Store name cannot start with an underscore.";
  } else if (!regex.test(storeName)) {
    error = "Only lowercase letters, numbers, and underscores are allowed.";
  } else if (isOnlyNumbers) {
    error =
      "Store name cannot contain only numbers; it must include at least 3 letters.";
  } else if (!hasAlphabets) {
    error = "Store name must contain at least 3 alphabets.";
  }

  return {
    isValid: error === "",
    error,
  };
};
